<template>
  <div>
    <component
      :is="component"
    />
  </div>
</template>
<script>

import Func47888Perfil from '@/views/47888/Func47888Perfil'

export default {
  name: 'Func47888',
  data () {
    return {
      component: Func47888Perfil
    }
  }
}
</script>
